import React from 'react';
import { CheckBoxWrapper, CheckBox, CheckBoxLabel } from './partials';
export var SwitchToggle = function SwitchToggle(_ref) {
  var size = _ref.size,
    id = _ref.id,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    onChange = _ref.onChange;
  var handleChange = function handleChange() {
    onChange(!checked);
  };
  return React.createElement("div", null, React.createElement(CheckBoxWrapper, {
    size: size
  }, React.createElement(CheckBox, {
    id: "checkbox-".concat(id),
    type: "checkbox",
    size: size,
    checked: checked,
    onChange: handleChange
  }), React.createElement(CheckBoxLabel, {
    htmlFor: "checkbox-".concat(id),
    size: size
  })));
};